// Проверяем наличие необходимых переменных окружения
const requiredEnvVars = ['REACT_APP_OPENAI_API_KEY'];

requiredEnvVars.forEach(envVar => {
  if (!process.env[envVar]) {
    throw new Error(`Missing required environment variable: ${envVar}`);
  }
});

// Конфигурация API
export const API_CONFIG = {
  OPENAI: {
    API_KEY: process.env.REACT_APP_OPENAI_API_KEY,
    BASE_URL: 'https://api.openai.com/v1',
    MODELS: {
      GPT4: 'gpt-4o-mini'
    }
  }
};

// Функция для обфускации API ключа при логировании
export const getObfuscatedKey = (key) => {
  if (!key) return '';
  return `${key.slice(0, 4)}...${key.slice(-4)}`;
};

// Проверка валидности API ключа
export const isValidApiKey = (key) => {
  return key && key.startsWith('sk-') && key.length > 20;
}; 